import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ServiceAppService } from '../../../security/service-app.service';
import { Table } from 'primeng/table';
import { FileUpload } from 'primeng/fileupload';
import { ICadastroDealer, ICadastroGestor, IFiltrosDealer, IListas } from './IFiltrosDealer';
import { DealerCadastroComponent } from './dealer-cadastro/dealer-cadastro.component';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-dealer',
  templateUrl: './dealer.component.html',
  styleUrls: ['./dealer.component.scss']
})
export class DealerNovoComponent implements OnInit {
  cols: any[];
  first = 0;
  rows = 10;
  dados: any[];
  _selectedColumns: any[];
  loading: boolean;
  totalRegistros: any = 0;
  selectedDados: any[] = [];
  exibeFiltros = false;
  exibeCadastro = false;
  filtrosNew: IFiltrosDealer;
  cadastroTitulo = '';
  cadastro: ICadastroDealer;
  cadastroGestor: ICadastroGestor;
  view = false;
  listas: IListas = {
    tiposDealer: [], gruposEconomicos: [], itensPais: [], itensRegiao: [],
    itensUf: [], itensCidade: [], itensRegional: []
  };

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;
  @ViewChild(DealerCadastroComponent, { static: false }) dealaerCadastro: DealerCadastroComponent;
  constructor(private service: ServiceAppService, private filtroService: FiltroService, private exportExcelService: ExportExcelService) { }

  ngOnInit() {

    this.filtrosNew = {
      nome: '', cnpj: '', codDealer: '', paginaAtual: 1, quantidadeRegistrosPorPagina: 10
    }

    this.cols = [
      { field: 'codigo', header: 'Dealer Code' },
      { field: 'nomeDealer', header: 'Descrição' },
      { field: 'cnpj', header: 'CNPJ' },
      { field: 'status', header: 'Ativo' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.listar();
    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  listar() {
    this.loading = true;
    this.service
      .getDados(`/dealer/listar?page=${this.filtrosNew.paginaAtual}&size=${this.filtrosNew.quantidadeRegistrosPorPagina}&nome=${this.filtrosNew.nome}&cnpj=${this.filtrosNew.cnpj}&dealer=${this.filtrosNew.codDealer}`)
      .subscribe(res => {
        this.dados = res;
        this.totalRegistros = res[0].totalRegistros;
        this.loading = false
      });
  }

  onPageChange(event: any): void {
    this.filtrosNew.paginaAtual = event.page + 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = event.rows;
    this.first = event.first;
    this.listar();
  }

  showFilters() {
    this.exibeFiltros = true;
  }

  exportExcel() {
    let registros = [];
    this.service
      .getDados(`/dealer/listar?page=1&size=${this.totalRegistros || 99999}&nome=${this.filtrosNew.nome}&cnpj=${this.filtrosNew.cnpj}&dealer=${this.filtrosNew.codDealer}`)
      .subscribe(res => {
        registros = res;

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = 'dealer';
          const mappedRows = registros.map(r => {
            const linha = {};
            this.cols.forEach(c => {
              if (c.field !== 'edit') {
                linha[(c.header)] = (r[c.field]);
              }
            });
            return linha;
          });

          const headers = this.cols.filter(c => c.field !== 'edit').map(c => c.header);
          const firstCol = headers[0] || '';
          const secondCol = headers[1] || '';

          const totalAtivos = registros.filter(r => r.status === 'S').length;
          const totalInativos = registros.filter(r => r.status === 'N').length;

          const buildRow = (label: string, value: string) => {
            const row = {};
            headers.forEach(h => row[h] = '');
            row[firstCol] = label;
            if (secondCol) { row[secondCol] = value; }
            return row;
          };

          mappedRows.push(buildRow('Total', `${registros.length} registro(s)`));
          mappedRows.push(buildRow('Ativos (S)', `${totalAtivos} registro(s)`));
          mappedRows.push(buildRow('Inativos (N)', `${totalInativos} registro(s)`));

          this.exportExcelService.ExportTOExcelJSON(mappedRows);
        }
      });
  }

  retornaAplicarFiltros(filtros: IFiltrosDealer) {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.filtrosNew = filtros;
    this.exibeFiltros = false;
    this.listar();
  }

  recarregaDados() {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.first = 0;
    this.listar();
  }

  insertDados(view: boolean) {
    this.cadastroTitulo = 'Cadastrar';
    this.view = view;
    this.cadastro = {
      codigo: '', nomeDealer: '', cnpj: '', status: '',
      incricaoMunicipal: '', incricaoEstadual: '', cep: '',
      pais: 0, regiao: 0, uf: 0, cidade: 0, logradouro: '', bairro: '',
      complemento: '', nomeContato: '', ddd: 0, telefone: 0, email: ''
    };

    this.cadastroGestor = {
      nomeGestorVeiculo: '', cpfGestorVeiculo: '', idGestorVeiculo: 0,
      nomeGestorPeca: '', cpfGestorPeca: '', idGestorPeca: 0,
      nomeGestorPosVenda: '', cpfGestorPosVenda: '', idGestorPosVenda: 0
    }

    this.carregarDDLGrupo();
    this.carregarDDLPais();
    this.carregarDDLRegiao();
    this.carregarDDLRegional();
    this.carregarDDLTipoDealer();
    this.exibeCadastro = true;
  }

  editDados(dado: ICadastroDealer, estado: boolean) {
    this.view = estado;
    this.service.getDados('/dealer/obterDealer?codDealer=' + dado.codigo).subscribe({
      next: (res) => {
        this.cadastroTitulo = estado ? 'Visualizar' : 'Editar';
        this.cadastro = { ...res };
        this.carregarDDL();
        this.exibeCadastro = true;
      },
      error: (error) => console.error(error)
    })
    this.service.getDados('/dealer/obterGestor?codDealer=' + dado.codigo).subscribe({
      next: (res) => {
        this.cadastroGestor = { ...res };
        this.cadastroGestor.nomeGestorPeca = res.nomeGestorPeca ? res.nomeGestorPeca : '';
        this.cadastroGestor.nomeGestorPosVenda = res.nomeGestorPosVenda ? res.nomeGestorPosVenda : '';
        this.cadastroGestor.nomeGestorVeiculo = res.nomeGestorVeiculo ? res.nomeGestorVeiculo : '';
        this.cadastroGestor.cpfGestorPeca = res.cpfGestorPeca ? res.cpfGestorPeca : '';
        this.cadastroGestor.cpfGestorPosVenda = res.cpfGestorPosVenda ? res.cpfGestorPosVenda : '';
        this.cadastroGestor.cpfGestorVeiculo = res.cpfGestorVeiculo ? res.cpfGestorVeiculo : '';
      },
      error: (error) => console.error(error)
    });
  }

  retornaFecharModalFiltros(dialog: boolean) {
    this.exibeFiltros = dialog;
  }

  retornaFecharModalCadastro(dialog: boolean) {
    this.exibeCadastro = dialog;
  }

  carregarDDL() {
    this.carregarDDLCidade(0)
    this.carregarDDLGrupo();
    this.carregarDDLPais();
    this.carregarDDLRegiao();
    this.carregarDDLTipoDealer();
    this.carregarDDLUf(0);
    this.carregarDDLRegional();
  }

  private carregarDDLTipoDealer() {
    this.filtroService.buscar('tipo_dealer')
      .then(r => { this.listas.tiposDealer = r.filtros; });
  }

  private carregarDDLGrupo() {
    this.filtroService.buscar('grupo_economico')
      .then(r => { this.listas.gruposEconomicos = r.filtros; });
  }

  private carregarDDLPais() {
    this.filtroService.buscar('pais')
      .then(r => { this.listas.itensPais = r.filtros; });
  }

  private carregarDDLRegiao() {
    this.filtroService.buscar('regiao')
      .then(r => { this.listas.itensRegiao = r.filtros; });
  }

  private carregarDDLRegional() {
    this.filtroService.buscar('regional')
      .then(r => { this.listas.itensRegional = r.filtros; });
  }

  private carregarDDLUf(idUf) {
    this.filtroService.buscar('estado/'.concat(this.cadastro.regiao.toString()))
      .then(r => { this.listas.itensUf = r.filtros; });

    if (idUf) {
      this.cadastro.uf = idUf;
      this.carregarDDLCidade(0);
    }
  }

  private carregarDDLCidade(idCidade) {
    this.filtroService.buscar('cidade/'.concat(this.cadastro.uf.toString()))
      .then(r => { this.listas.itensCidade = r.filtros; });

    if (idCidade) {
      this.cadastro.cidade = idCidade;
    }
  }
}
